import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Table, TableModule } from 'primeng/table';
import { Tooltip, TooltipModule } from 'primeng/tooltip';
import { DangerousGoods } from 'src/app/domain/DangerousGoods';
import { ADRService } from 'src/app/services/adr.service';

@Component({
  selector: 'app-dangerous-shipment-preview',
  standalone: true,
  imports: [CommonModule,
    TableModule,
    ButtonModule,
    DropdownModule,
    FormsModule,
    ReactiveFormsModule,
    DividerModule,
    TranslateModule,
    InputTextModule,
    AutoCompleteModule,
    CheckboxModule,
    TooltipModule,
    ProgressSpinnerModule],
  templateUrl: "./DangerousShipmentPreview.componet.html",
  styleUrls: ['./DangerousShipmentPreview.component.scss']
})
export class DangerousShipmentPreviewComponent implements OnInit, OnChanges {
  @Input() editable: boolean = false;
  @Input("shipment") shipment: any;
  @Output("onShipmentChanges") onShipmentChanges = new EventEmitter<any>(false);
  @ViewChild('adrTable') table: Table;
  foundAdrs: DangerousGoods[] = [];
  testCount = 0;
  ADRFormGroup = new FormGroup({
    ADRLines: new FormArray([])
  }, Validators.required)

  holding = false;
  timeout: any;

  get GetADRFormControls() {
    return this.ADRFormGroup.controls.ADRLines as FormArray;
  }

  get CreateFormGroup() {
    this.testCount++;
    return new FormGroup({
      shipmentId: new FormControl(),
      colliId: new FormControl(),
      name: new FormControl(),
      unNumber: new FormControl(),
      class: new FormControl(),
      waybillString: new FormControl(),
      packageGroup: new FormControl(),
      transportCategory: new FormControl(),
      imdg: new FormControl(),
      liquid: new FormControl(),
      environmental: new FormControl(),
      netWeightKg: new FormControl(),
      grossWeightKg: new FormControl(),
      volumeM3: new FormControl(),
      colliQuantity: new FormControl(),
      packaging: new FormControl(),
      RowId: new FormControl(this.testCount),
      AdrCode: new FormControl(null, Validators.required),
      // ADRLiquneVolume: new FormControl(),
      ADRSoildVolume: new FormControl(),
      lowQuantity: new FormControl(false),
      SelectedAdr: new FormControl(null, [Validators.required, Validators.minLength(6)]),
      Points: new FormControl(null)
    }, { validators: this.positiveVolumeValidator() })
  }

  constructor(private adrService: ADRService, private confirmationService: ConfirmationService, private translateService: TranslateService, private messageService: MessageService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["shipment"]) {
      this.shipment = changes["shipment"].currentValue;
      if (this.shipment.dangerousGoods.length > 0)
        this.MapToFormControll();
    }
  }
  ngOnInit(): void {
    this.ADRFormGroup.statusChanges.subscribe(x => {
      if (x == "VALID")
        this.shipmentChange();
    })
  }

  waybillShortString(dangerousGood: any) {
    return dangerousGood.waybillString?.substring(0, 80);
  }

  adrSearch(event: any) {
    if (event.query == "UN" || event.query == "un") {
      this.foundAdrs = [];
      return;
    }
    if (event.query.includes('UN')) {
      event.query = event.query.replace('UN', '').trim();
    }
    if (event.query.includes('un')) {
      event.query = event.query.replace('un', '').trim();
    }

    this.adrService.searchADR(event.query).subscribe((data: any) => {
      if (data && data.items) {
        this.foundAdrs = data.items;
      }
    });
  }

  RemoveAdrLine(line: FormGroup) {
    let controllIndex = this.GetADRFormControls.controls.findIndex(x => x.get('RowId').value == line.get('RowId').value);
    this.ADRFormGroup.controls.ADRLines.removeAt(controllIndex);
    this.table.cancelRowEdit(line);
    this.shipmentChange();
  }

  GetLiquneTotalSum() {
    let sum = 0;
    // this.GetADRFormControls.controls.forEach(x => sum += x.get('ADRLiquneVolume').value);
    return sum
  }

  GetSolidTotalSum() {
    let sum = 0;
    this.GetADRFormControls.controls.forEach(x => sum += x.get('ADRSoildVolume').value);
    return sum
  }

  MapToFormControll() {
    this.GetADRFormControls.clear();
    this.shipment.dangerousGoods.forEach((adr: DangerousGoods) => {
      let tempformGroup = this.CreateFormGroup;
      tempformGroup.controls.class.setValue(adr.class);
      tempformGroup.controls.colliId.setValue(adr.colliId);
      tempformGroup.controls.colliQuantity.setValue(adr.colliQuantity);
      tempformGroup.controls.environmental.setValue(adr.environmental);
      tempformGroup.controls.grossWeightKg.setValue(adr.grossWeightKg);
      tempformGroup.controls.imdg.setValue(adr.imdg);
      tempformGroup.controls.liquid.setValue(adr.liquid);
      tempformGroup.controls.name.setValue(adr.name);
      tempformGroup.controls.netWeightKg.setValue(adr.netWeightKg);
      tempformGroup.controls.packageGroup.setValue(adr.packageGroup);
      tempformGroup.controls.packaging.setValue(adr.packaging);
      tempformGroup.controls.shipmentId.setValue(adr.shipmentId);
      tempformGroup.controls.transportCategory.setValue(adr.transportCategory);
      tempformGroup.controls.unNumber.setValue(adr.unNumber);
      tempformGroup.controls.volumeM3.setValue(adr.volumeM3);
      tempformGroup.controls.waybillString.setValue(adr.waybillString);
      tempformGroup.controls.lowQuantity.setValue(adr.lowQuantity);

      tempformGroup.get('AdrCode').setValue(adr.unNumber ?? "");
      tempformGroup.get('ADRSoildVolume').setValue(adr.grossWeightKg ?? 0);
      // tempformGroup.get('ADRLiquneVolume').setValue(adr.liquidLiter ?? 0);      
      tempformGroup.get('SelectedAdr').setValue({ class: adr.class, name: adr.name, waybillString: adr.waybillString, unNumber: adr.unNumber, lowQuantity: adr.lowQuantity });
      tempformGroup.controls.Points.setValue(adr.point);
      this.GetADRFormControls.push(tempformGroup);
    })
  }

  /**
   * adds a new formgroup
   */
  AddADRLine() {
    this.testCount += 1;
    this.ADRFormGroup.controls.ADRLines.push(this.CreateFormGroup);
    this.ADRFormGroup.controls.ADRLines.controls.reverse();
  }
  /**
   * assigns the un code to the line formgroup.
   */
  SetAdrCodeOnForm(event: any, formc: FormControl) {
    formc.get('AdrCode')?.setValue(event.unNumber)
  }

  /**
   * 
   * @returns weather or not the sum of soild and liqune is over 0
   */
  positiveVolumeValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      // const liquid = group.get('ADRLiquneVolume')?.value || 0;
      const liquid = 0;
      const solid = group.get('ADRSoildVolume')?.value || 0;
      return (liquid + solid) > 0 ? null : { volumeInvalid: true };
    };
  }

  shipmentChange() {
    // ob.bookholydays
    if (this.shipment.dangerousGoods && this.shipment.dangerousGoods > 0) {
      this.shipment.dangerousGoods = [];
      this.GetADRFormControls.controls.forEach((adr: FormGroup) => {
        let tempformGroup = {} as DangerousGoods;
        tempformGroup.class = adr.controls.class.value;
        tempformGroup.colliId = adr.controls.colliId.value;
        tempformGroup.colliQuantity = adr.controls.colliQuantity.value;
        tempformGroup.environmental = adr.controls.environmental.value;
        tempformGroup.grossWeightKg = adr.controls.grossWeightKg.value;
        tempformGroup.imdg = adr.controls.imdg.value;
        tempformGroup.liquid = adr.controls.liquid.value;
        tempformGroup.name = adr.controls.name.value;
        tempformGroup.netWeightKg = adr.controls.netWeightKg.value;
        tempformGroup.packageGroup = adr.controls.packageGroup.value;
        tempformGroup.packaging = adr.controls.packaging.value;
        tempformGroup.shipmentId = adr.controls.shipmentId.value;
        tempformGroup.transportCategory = adr.controls.transportCategory.value;
        tempformGroup.unNumber = adr.controls.unNumber.value;
        tempformGroup.volumeM3 = adr.controls.volumeM3.value;
        tempformGroup.waybillString = adr.controls.waybillString.value;

        // tempformGroup.get('AdrCode').setValue(adr.controls.unNumber.value ?? "");
        // tempformGroup.get('ADRSoildVolume').setValue(adr.controls.grossWeightKg.value ?? 0);
        // tempformGroup.get('ADRLiquneVolume').setValue(adr.liquidLiter ?? 0);      
        // tempformGroup.get('SelectedAdr').setValue({ class: adr.controls.class.value, name: adr.controls.name.value, waybillString: adr.controls.waybillString.value, unNumber: adr.controls.unNumber.value });
        this.shipment.dangerousGoods.push(tempformGroup)
        // this.GetADRFormControls.push(tempformGroup);
      })
      this.onShipmentChanges.emit({ data: this.shipment.dangerousGoods })
    }
  }


  RemoveAdrFromShipment(line: FormGroup) {
    this.confirmationService.confirm({
      header: this.translateService.instant('DANGEROUSGOODSTABLEHEADER.REMOVEDANGEROUSGOODSHEADER') + " UN " + line.controls.AdrCode?.value,
      message: this.translateService.instant('DANGEROUSGOODSTABLEHEADER.REMOVEDANGEROUSGOODSMESSAGE'),
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translateService.instant('GENERIC.YES'),
      rejectLabel: this.translateService.instant('GENERIC.CLOSE'),
      key: 'deleteColliConfirm',
      accept: () => {
        this.RemoveAdrLine(line);
        this.messageService.add({
          severity: 'success',
          summary: this.translateService.instant('DELETED'),
          detail: "UN " + line.controls.AdrCode?.value + " " + this.translateService.instant('DANGEROUSGOODSTABLEHEADER.REMOVEDANGEROUSGOODSFROMSHIPMENT'),
        });
      },
      reject: () => { },
    });
  }
  GetTotalPointSum(): number {
    let sum = 0;
    this.GetADRFormControls.controls.forEach(x => sum += x.get('Points').value ?? 0);
    return sum;
  }
}

